import {createVuetify} from "vuetify";
import "vuetify/styles";
import '@mdi/font/css/materialdesignicons.css'
import {aliases, mdi} from "vuetify/iconsets/mdi";
import { fa } from 'vuetify/locale'

// for testing
export default createVuetify({
    defaults: {
        VTextField: {
            color: 'primary',
            variant: 'outlined',
            density: 'compact',
            hideDetails: 'auto'
        },
        VSelect: {
            color: 'primary',
            variant: 'outlined',
            density: 'compact',
            hideDetails: 'auto'
        },
        VAutocomplete: {
            color: 'primary',
            variant: 'outlined',
            density: 'compact',
            hideDetails: 'auto'
        },
        VFileInput: {
            color: 'primary',
            variant: 'outlined',
            density: 'compact',
            hideDetails: 'auto'
        },
        VTextarea: {
            color: 'primary',
            variant: 'outlined',
            density: 'compact',
            hideDetails: 'auto'
        },
        VCombobox: {
            color: 'primary',
            variant: 'outlined',
            density: 'compact',
            hideDetails: 'auto'
        }
    },
    theme: {
        defaultTheme: "light",
        themes: {
            light: {
                dark: false,
                colors: {
                    primary: "#2499EF",
                    secondary: "#8A8D93",
                    "on-secondary": "#fff",
                    success: "#27CE88",
                    info: "#8C8DFF",
                    warning: "#FE8969",
                    error: "#FF316F",
                    "on-primary": "#FFFFFF",
                    "on-success": "#FFFFFF",
                    "on-warning": "#FFFFFF",
                    background: "#F4F5FA",
                    "on-background": "#1d1f20",
                    "on-surface": "#1d1f20",
                    "grey-50": "#FAFAFA",
                    "grey-100": "#F5F5F5",
                    "grey-200": "#EEEEEE",
                    "grey-300": "#E0E0E0",
                    "grey-400": "#BDBDBD",
                    "grey-500": "#9E9E9E",
                    "grey-600": "#757575",
                    "grey-700": "#616161",
                    "grey-800": "#424242",
                    "grey-900": "#647283",

                    "primary-50": "#F1F8FE",
                    "primary-100": "#E5F3FD",
                    "primary-200": "#C6E7FF",
                    "primary-300": "#7EC9FF",
                    "primary-400": "#45ABF6",
                    "primary-500": "#2499EF",
                    "primary-600": "#0E73BE",
                    "primary-700": "#0B568E",
                    "primary-800": "#094876",
                    "primary-900": "#073A5F",
                },

                variables: {},
            },
            dark: {
                dark: true,
                colors: {
                    primary: "#2499EF",
                    secondary: "#8A8D93",
                    "on-secondary": "#fff",
                    success: "#27CE88",
                    info: "#8C8DFF",
                    warning: "#FE8969",
                    error: "#FF316F",
                    "on-primary": "#FFFFFF",
                    "on-success": "#FFFFFF",
                    "on-warning": "#FFFFFF",
                    background: "#1d1f20",
                    "on-background": "#E7E3FC",
                    surface: "#1d1f20",
                    "on-surface": "#E7E3FC",
                    "grey-50": "#2A2E42",
                    "grey-100": "#2F3349",
                    "grey-200": "#4A5072",
                    "grey-300": "#5E6692",
                    "grey-400": "#7983BB",
                    "grey-500": "#8692D0",
                    "grey-600": "#AAB3DE",
                    "grey-700": "#B6BEE3",
                    "grey-800": "#CFD3EC",
                    "grey-900": "#E7E9F6",

                    "primary-50": "#F1F8FE",
                    "primary-100": "#E5F3FD",
                    "primary-200": "#C6E7FF",
                    "primary-300": "#7EC9FF",
                    "primary-400": "#45ABF6",
                    "primary-500": "#2499EF",
                    "primary-600": "#0E73BE",
                    "primary-700": "#0B568E",
                    "primary-800": "#094876",
                    "primary-900": "#073A5F",
                },
            },
        },
    },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
        }
    }
});